import * as XLSX from 'xlsx';

export const exportUtils = {
  toCSV: (data, columns, fileName = 'export') => {
  try {
    const headers = columns.map(col => col.header);

    const csvContent = [
      headers.join(','),
      ...data.map(item => {
        return columns.map(col => {
          let value = typeof col.accessor === 'function'
            ? col.accessor(item)
            : col.accessor.split('.').reduce((obj, key) => obj?.[key], item) || '';

          value = String(value);

          // If long numeric string → force Excel to treat as text
          if (/^\d+$/.test(value) && value.length > 15) {
            value = `="${value}"`;
          }

          // Escape quotes
          const escapedValue = value.replace(/"/g, '""');

          return escapedValue.includes(',') || escapedValue.includes('"')
            ? `"${escapedValue}"`
            : escapedValue;
        }).join(',');
      })
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', `${fileName}_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return true;
  } catch (error) {
    console.error('Failed to export CSV:', error);
    return false;
  }
},

  toExcel: (data, columns, fileName = 'export') => {
  try {
    const wb = XLSX.utils.book_new();

    // Build worksheet manually so we can control cell types
    const ws = {};

    const headerRow = columns.map(col => col.header);
    const allData = [headerRow];

    data.forEach(item => {
      const row = columns.map(col => {
        return typeof col.accessor === 'function'
          ? col.accessor(item)
          : col.accessor.split('.').reduce((obj, key) => obj?.[key], item) || '';
      });
      allData.push(row);
    });

    // Add data to worksheet with controlled types
    allData.forEach((row, rowIndex) => {
      row.forEach((cellValue, colIndex) => {
        const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });

        let value = cellValue ?? '';

        // Force long numeric strings to TEXT
        if (
          typeof value === 'string' &&
          /^\d+$/.test(value) &&
          value.length > 15
        ) {
          ws[cellAddress] = {
            v: value,
            t: 's' // force string type
          };
        } else {
          ws[cellAddress] = {
            v: value,
            t: typeof value === 'number' ? 'n' : 's'
          };
        }
      });
    });

    // Define sheet range
    ws['!ref'] = XLSX.utils.encode_range({
      s: { r: 0, c: 0 },
      e: { r: allData.length - 1, c: columns.length - 1 }
    });

    // Set column widths
    ws['!cols'] = columns.map(col => ({ wch: col.width || 15 }));

    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(
      wb,
      `${fileName}_${new Date().toISOString().split('T')[0]}.xlsx`
    );

    return true;
  } catch (error) {
    console.error('Failed to export Excel:', error);
    return false;
  }
},


  toPDF: (data, columns, fileName = 'export', title = 'Report') => {
    try {
      const { jsPDF } = window.jspdf;
      const doc = new jsPDF();
      
      // Add title
      doc.setFontSize(16);
      doc.text(title, 14, 15);
      
      doc.setFontSize(10);
      doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 25);
      doc.text(`Total Records: ${data.length}`, 14, 32);
      
      // Prepare data
      const headers = columns.map(col => col.header);
      const pdfData = data.map(item => {
        return columns.map(col => {
          return typeof col.accessor === 'function' 
            ? col.accessor(item)
            : col.accessor.split('.').reduce((obj, key) => obj?.[key], item) || '';
        });
      });
      
      doc.autoTable({
        head: [headers],
        body: pdfData,
        startY: 40,
        theme: 'grid',
        headStyles: { fillColor: [71, 47, 146] },
        styles: { fontSize: 8 },
        columnStyles: columns.reduce((acc, col, index) => {
          acc[index] = { cellWidth: col.pdfWidth || 30 };
          return acc;
        }, {})
      });
      
      doc.save(`${fileName}_${new Date().toISOString().split('T')[0]}.pdf`);
      
      return true;
    } catch (error) {
      console.error('Failed to export PDF:', error);
      return false;
    }
  }
};